export const APP_STATE = {
  subMenu: 'subMenu',
  conversation_init: 'convesation_init',
  convesation_bulle_children: 'convesation_bulle_children',
  convesation_bulle_link: 'convesation_bulle_link',
  convesation_bulle_note: 'convesation_bulle_note',
  convesation_back: 'convesation_back',
};
